<template>
    <div>
        <v-btn class="my-2" :color="edit ? 'blue' : 'orange'" dark @click="toggleHiddenEdit">
            <v-icon left>edit</v-icon>
            <span v-if="!edit">Rediger lokasjoner</span>
            <span v-else>Lagre skjulte lokasjoner</span>
        </v-btn>

        <div>
            <div class="location-items">
                <div v-for="segment in locationLists" :key="segment[0]" class="location-item">
                    <div v-for="location in segment" :key="location" class="location-item-body">
                        <div v-if="hiddenLocations[location]" :class="{'location-hidden': !edit}">
                            <span v-if="edit">{{ location }}</span>
                            <div class="location-occupied-list" v-if="edit">
                                <strong class="blue--text text--darken-3 cursor-pointer"
                                        @click="hideLocations([location])">
                                    Vis igjen
                                </strong>
                            </div>
                        </div>
                        <div v-else-if="!locations[location]" class="green lighten-4 location-available">
                            <div>{{ location }}</div>
                            <div class="location-occupied-list" v-if="!edit">
                                <strong class="green--text text--darken-3">Ledig</strong>
                            </div>
                            <div class="location-occupied-list" v-else>
                                <strong class="red--text text--darken-3 cursor-pointer"
                                        @click="hideLocations([location])">&times; Skjul</strong>
                            </div>
                        </div>
                        <div v-else class="grey lighten-1 location-occupied">
                            <div>{{ location }}</div>
                            <div class="location-occupied-list">
                                <router-link
                                    :to="{name: 'TireStorage', params: {id: storage.car_id, storage: storage.id} }"
                                    v-for="storage in locations[location]" :key="storage.id"
                                    :title="storage.location">
                                    {{ storage.car.reg_number }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="pl-2" v-if="edit">
                        <v-btn color="red" text @click="hideLocations(segment)">
                            <v-icon left>close</v-icon>
                            Skjul rad
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    created() {
        this.loadData();
    },

    data() {
        return {
            locations: [],
            ranges: null,
            edit: false,
            hiddenLocations: {},
            letterRangeMax: []
        }
    },

    methods: {
        loadData() {
            this.$http.get(`locations`).then(response => {
                this.locations = response.data.data;
                this.ranges = response.data.ranges;
                this.hiddenLocations = response.data.hidden;
                this.letterRangeMax = response.data.letterRangeMax;
            });
        },
        toggleHiddenEdit() {
            this.edit = !this.edit;

            if (!this.edit) {
                this.$http.post(`locations/overrides`, {hidden: this.hiddenLocations}).then(response => {
                    this.hiddenLocations = response.data.data;
                });
            }
        },
        hideLocations(locations) {
            locations.forEach(loc => {
                if (this.hiddenLocations[loc]) {
                    delete this.hiddenLocations[loc];
                } else if (!this.locations[loc]) {
                    this.hiddenLocations[loc] = true;
                }
            });
            this.hiddenLocations = {...this.hiddenLocations}
        },
    },

    computed: {
        allLocations() {
            if (!this.ranges) return null;
            let range = this.ranges.min.map(it => it);

            let rangeRanges = [];
            let rangeValues = [];

            range.forEach((pair, index) => {
                let from1 = pair.charCodeAt(0);
                let from2 = pair.charCodeAt(1);
                let maxRange = this.ranges.max[index];
                let numValues = 0;
                let pairValues = [];
                let numericStart = parseInt(pair, 10);
                if (pair === ('' + numericStart).padStart(2, '0')) {
                    let numericEnd = parseInt(maxRange, 10);
                    for (let i = numericStart; i <= numericEnd; i++) {
                        pairValues.push((i + '').padStart(2, '0'));
                        numValues++;
                    }
                } else {
                    let to1 = maxRange.charCodeAt(0);
                    let to2 = maxRange.charCodeAt(1);
                    let a = from1;
                    while (a <= to1) {
                        let b = from2;

                        // Check max number in LETTER[NUMBER] - ie. A4, max number is 4 
                        let letterrangemax = this.letterRangeMax[String.fromCharCode(a)];
                        if (letterrangemax !== undefined) {

                            let letterrangemaxCharcode = letterrangemax.charCodeAt(0);
                            
                            while (b <= letterrangemaxCharcode) {
                                pairValues.push(String.fromCharCode(a) + String.fromCharCode(b));
                                numValues++;
                                b++;
                            }
                        }
                        a++;

                        
                    }
                }

                rangeValues.push(numValues);
                rangeRanges.push(pairValues);
            });

            let recurse = (a, b) => {
                let lst = [];
                for (let i = 0; i < a.length; i++) {
                    for (let j = 0; j < b.length; j++) {
                        lst.push(a[i] + '-' + b[j]);
                    }
                }
                return lst;
            }
            return {
                dimensions: rangeValues,
                locations: recurse(rangeRanges[0], recurse(rangeRanges[1], rangeRanges[2]))
            };
        },
        locationLists() {
            let allLocations = this.allLocations;
            if (!allLocations) return [];

            let {dimensions, locations} = this.allLocations;
            let numLocations = locations.length;
            console.log(dimensions)
            let setSize = numLocations / dimensions[0] / dimensions[1];
            let offset = 0;
            let segmentedLocations = [];
            while (offset < numLocations) {
                segmentedLocations.push(locations.slice(offset, offset + setSize));
                offset += setSize;
            }

            return segmentedLocations;
        }
    },
}
</script>

<style lang="scss">
.location-items {
    border-left: 1px solid rgba(#000, 0.2);
    border-bottom: 1px solid rgba(#000, 0.2);
    display: inline-block;
}

.location-item {
    display: flex;
    text-transform: uppercase;
    align-items: center;

    .location-item-body {
        text-align: center;

        > div {
            padding: 0.4rem 0.5rem;
            width: 120px;
            height: 50px;
            overflow: hidden;
        }

        small {
            line-height: 1;
        }

        a {
            color: #000;
        }
    }

    .location-hidden {
        height: auto !important;
        padding: 0 !important;
        border-width: 0 !important;
    }

    .location-available {

    }

    .location-occupied-list {
        line-height: 1;
        font-size: 70%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }
}
</style>
